export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#FF0055" />
    <g transform="rotate(-5 32 32)">
      <g fill="none" stroke="#0B0A0F" strokeLinecap="round">
        <path d="M15 38 L18.5 15" strokeWidth="4.6" />
        <path d="M18.5 15 L27.5 31" strokeWidth="4" />
        <path d="M27.5 31 L31.5 11" strokeWidth="4.6" />
        <path d="M31.5 11 L40.5 29.5" strokeWidth="4" />
        <path d="M40.5 29.5 L46.5 12.5" strokeWidth="4.6" />
        <path d="M46.5 12.5 L48.5 36" strokeWidth="4" />
        <path d="M14 42.5 L49 40.5" strokeWidth="5.2" />
        <path d="M15.5 49.5 L48 47.5" strokeWidth="5.2" />
      </g>
      <g fill="#0B0A0F">
        <circle cx="19" cy="10" r="1.7" />
        <circle cx="32" cy="6.5" r="1.7" />
        <circle cx="47" cy="8" r="1.7" />
      </g>
    </g>
  </svg>
);

export const Asterisk = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
    <g stroke="currentColor" strokeWidth="3.4" strokeLinecap="round">
      <line x1="12" y1="2.5" x2="12" y2="21.5" />
      <line x1="2.5" y1="12" x2="21.5" y2="12" />
      <line x1="5.3" y1="5.3" x2="18.7" y2="18.7" />
      <line x1="18.7" y1="5.3" x2="5.3" y2="18.7" />
    </g>
  </svg>
);

export const PlatformIcon = ({ id, className = "h-6 w-6" }) => {
  if (id === "spotify")
    return (
      <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
        <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4.59 14.44a.79.79 0 0 1-1.08.26c-2.96-1.8-6.68-2.21-11.07-1.21a.78.78 0 0 1-.94-.59.79.79 0 0 1 .6-.94c4.83-1.1 8.98-.63 12.33 1.4.36.22.48.7.16 1.08Zm1.22-2.72a.98.98 0 0 1-1.35.32c-3.39-2.08-8.55-2.68-12.56-1.47a.98.98 0 0 1-1.23-.66.98.98 0 0 1 .66-1.22c4.56-1.38 10.24-.71 14.13 1.68.47.28.62.9.35 1.35Zm.11-2.83c-4.06-2.41-10.76-2.63-14.63-1.45a1.18 1.18 0 0 1-1.48-.79 1.18 1.18 0 0 1 .79-1.47c4.42-1.34 11.78-1.08 16.42 1.68a1.18 1.18 0 0 1-1.1 2.03Z" />
      </svg>
    );
  if (id === "apple")
    return (
      <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
        <path d="M12 2a10 10 0 0 0-4.1 19.11c-.03-.66-.02-1.4.13-2.13.16-.83.99-3.34 1.23-4.15a3.35 3.35 0 0 1-.28-1.38c0-1.29.75-2.29 1.68-2.29.79 0 1.17.6 1.17 1.31 0 .8-.51 1.99-.77 3.1-.22.93.46 1.68 1.37 1.68 1.65 0 2.76-2.11 2.76-4.62 0-1.9-1.28-3.33-3.61-3.33-2.63 0-4.27 1.96-4.27 4.15 0 .76.22 1.29.57 1.7.16.19.18.27.12.49l-.17.66c-.05.2-.22.28-.41.2-1.14-.46-1.67-1.71-1.67-3.11 0-2.31 1.95-5.08 5.82-5.08 3.11 0 5.15 2.25 5.15 4.67 0 3.2-1.78 5.59-4.4 5.59-.88 0-1.7-.48-1.99-1.02l-.54 2.14c-.19.71-.57 1.42-.92 1.98A10 10 0 1 0 12 2Z" />
      </svg>
    );
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M23.5 6.19a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.5A3.02 3.02 0 0 0 .5 6.19C0 8.07 0 12 0 12s0 3.93.5 5.81a3.02 3.02 0 0 0 2.12 2.14c1.88.5 9.38.5 9.38.5s7.5 0 9.38-.5a3.02 3.02 0 0 0 2.12-2.14C24 15.93 24 12 24 12s0-3.93-.5-5.81ZM9.55 15.57V8.43L15.82 12l-6.27 3.57Z" />
    </svg>
  );
};

export const SocialIcon = ({ id, className = "h-4 w-4" }) => {
  if (id === "instagram")
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" />
        <circle cx="12" cy="12" r="4.4" />
        <circle cx="17.6" cy="6.4" r="1.1" fill="currentColor" stroke="none" />
      </svg>
    );
  if (id === "tiktok")
    return (
      <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
        <path d="M16.6 3c.36 2.1 1.9 3.72 4.4 3.9v3.02c-1.62.1-3.13-.35-4.4-1.22v6.62c0 4.06-2.9 6.18-6 6.18-2.93 0-5.6-2.1-5.6-5.42 0-3.44 3.06-5.63 6.3-5.28v3.14c-1.6-.32-3.14.6-3.14 2.18 0 1.44 1.2 2.32 2.5 2.32 1.42 0 2.46-.96 2.46-2.9V3h3.48Z" />
      </svg>
    );
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M18.9 3H22l-6.8 7.8L23.2 21h-6.3l-4.9-6.4L6.4 21H3.3l7.3-8.3L1.2 3h6.5l4.4 5.8L18.9 3Zm-1.1 16.1h1.7L7.6 4.8H5.7l12.1 14.3Z" />
    </svg>
  );
};
